import React from 'react';
import { connect } from 'react-redux';
import { DBDropDownObjective, DBTextFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'
import { StrengthPelvicFloorEndurance } from './StrengthPelvicFloorEndurance'
import { StrengthPelvicFloorFrequency } from './StrengthPelvicFloorFrequency'
import { StrengthPelvicFloorPower } from './StrengthPelvicFloorPower'
import { StrengthPelvicFloorRepitition } from './StrengthPelvicFloorRepitition'
import { StrengthPelvicFloorCoContraction } from './StrengthPelvicFloorCoContraction'
import { StrengthPelvicFloorElevation } from './StrengthPelvicFloorElevation'
import { StrengthPelvicFloorTiming } from './StrengthPelvicFloorTiming'
import { StrengthSitUp } from './StrengthSitUp'
import { StrengthGripStrength } from './StrengthGripStrength'
import { StrengthKeyGrip } from './StrengthKeyGrip'
import { StrengthPinchGrip } from './StrengthPinchGrip'

const components = {
    StrengthPelvicFloorPower,
    StrengthPelvicFloorEndurance,
    StrengthPelvicFloorFrequency,
    StrengthPelvicFloorElevation,
    StrengthPelvicFloorRepitition,
    StrengthPelvicFloorCoContraction,
    StrengthPelvicFloorTiming,
    StrengthSitUp,
    StrengthGripStrength,
    StrengthKeyGrip,
    StrengthPinchGrip
}


class PatientCareCenterNoteObjectiveStrPanel extends React.Component {

    renderChild(name, mopno) {
        const Child = components[name];
        return Child === undefined ? <span key={name} mopno={mopno} /> : <Child key={name} mopno={mopno} />;
    }

    render() {

        switch (this.props.panel.MOPMPTNO) {
            case 1:
                return (
                    <div className={styles.textfield_row}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.panel.MOPNO} flagText={'Strength - ' + this.props.panel.MOPLABEL} />
                        <label className={styles.label}>{this.props.panel.MOPLABEL}</label>
                        <span className={styles.r} />
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESTR'
                            entityKeyColumn='STNO'
                            entityKeyValue={this.props.stno}
                            field={this.props.panel.MOPCOLUMNPREFIX}
                            className={styles.c}
                            masterEntity='PTMASTERSTRENGTH'
                            masterEntityKeyColumn='MSTNO'
                            masterEntitySort='MSTORDER'
                            masterEntityDisplay='MSTNAME'
                        />
                        <span className={styles.l} >
                            <span className={styles.prev_wrapper}>
                                {this.props.prevStr}
                            </span>
                        </span>
                    </div>
                );
            case 2:
                return (
                    <div className={styles.textfield_row}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.panel.MOPNO} flagText={'Strength - ' + this.props.panel.MOPLABEL} />
                        <label className={styles.label}>{this.props.panel.MOPLABEL}</label>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESTR'
                            entityKeyColumn='STNO'
                            entityKeyValue={this.props.stno}
                            field={this.props.panel.MOPCOLUMNPREFIX + 'R'}
                            className={styles.r}
                            masterEntity='PTMASTERSTRENGTH'
                            masterEntityKeyColumn='MSTNO'
                            masterEntitySort='MSTORDER'
                            masterEntityDisplay='MSTNAME'
                        />
                        <span className={styles.c} >
                            <span className={styles.prev_wrapper}>
                                {this.props.prevStrR}
                            </span>
                        </span>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESTR'
                            entityKeyColumn='STNO'
                            entityKeyValue={this.props.stno}
                            field={this.props.panel.MOPCOLUMNPREFIX + 'L'}
                            className={styles.l}
                            masterEntity='PTMASTERSTRENGTH'
                            masterEntityKeyColumn='MSTNO'
                            masterEntitySort='MSTORDER'
                            masterEntityDisplay='MSTNAME'
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevStrL}
                        </span>

                    </div>
                );

            case 3:
                // return <div className={styles.row}>{'Type3: ' + this.props.panel.MOPNAME}</div>
                return this.renderChild(this.props.panel.MOPNAME, this.props.panel.MOPNO);



            case 16:
                return (
                    <div className={styles.textfield_row}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.panel.MOPNO} flagText={'Strength - ' + this.props.panel.MOPLABEL} />
                        <label className={styles.label}>{this.props.panel.MOPLABEL}</label>
                        <DBTextFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESTR'
                            entityKeyColumn='STNO'
                            entityKeyValue={this.props.stno}
                            field={this.props.panel.MOPCOLUMNPREFIX + 'R'}
                            className={styles.r}
                        />
                        <span className={styles.c} >
                            <span className={styles.prev_wrapper}>
                                {this.props.prevStrR}
                            </span>
                        </span>
                        <DBTextFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESTR'
                            entityKeyColumn='STNO'
                            entityKeyValue={this.props.stno}
                            field={this.props.panel.MOPCOLUMNPREFIX + 'L'}
                            className={styles.l}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevStrL}
                        </span>

                    </div>
                );



            default:
                return (
                    <div />
                );
        }
    }
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));
    let panel = state.entities.masterData.PTMASTEROBJECTIVEPANELS[ownprops.panelId];
    let flagged = false;

    // HACK: these are PKs from the PTMASTERSTRENGTH table that should cause a flag b/c they are out of norm;
    // probably should have a column in this table that we see if it should be "flagged" instead.
    let flagValues = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

    if (panel.MOPMPTNO === 1 &&
        state.entities.notes.PTOBJECTIVESTR[stno][panel.MOPCOLUMNPREFIX] !== null &&
        flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno][panel.MOPCOLUMNPREFIX])
    ) {
        flagged = true;
    }
    else if (panel.MOPMPTNO === 2 &&
        state.entities.notes.PTOBJECTIVESTR[stno][panel.MOPCOLUMNPREFIX + 'R'] !== null &&
        flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno][panel.MOPCOLUMNPREFIX + 'R'])
    ) {
        flagged = true;
    }
    else if (panel.MOPMPTNO === 2 &&
        state.entities.notes.PTOBJECTIVESTR[stno][panel.MOPCOLUMNPREFIX + 'L'] !== null &&
        flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno][panel.MOPCOLUMNPREFIX + 'L'])
    ) {
        flagged = true;
    } else if (panel.MOPMPTNO === 16 &&
        (state.entities.notes.PTOBJECTIVESTR[stno][panel.MOPCOLUMNPREFIX + 'L'] !== null ||
            state.entities.notes.PTOBJECTIVESTR[stno][panel.MOPCOLUMNPREFIX + 'R'] !== null)
    ) {
        flagged = true;
    }

    let prevStr = '';
    let prevStrR = '';
    let prevStrL = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVESTRPREV[pk]) {
        if (panel.MOPMPTNO === 1) {
            prevStr = state.entities.notes.PTOBJECTIVESTRPREV[pk][panel.MOPCOLUMNPREFIX] ?
                state.entities.masterData.PTMASTERSTRENGTH[state.entities.notes.PTOBJECTIVESTRPREV[pk][panel.MOPCOLUMNPREFIX]].MSTNAME :
                '';
        }
        if (panel.MOPMPTNO === 2) {
            prevStrR = state.entities.notes.PTOBJECTIVESTRPREV[pk][panel.MOPCOLUMNPREFIX + 'R'] ?
                state.entities.masterData.PTMASTERSTRENGTH[state.entities.notes.PTOBJECTIVESTRPREV[pk][panel.MOPCOLUMNPREFIX + 'R']].MSTNAME :
                '';
            prevStrL = state.entities.notes.PTOBJECTIVESTRPREV[pk][panel.MOPCOLUMNPREFIX + 'L'] ?
                state.entities.masterData.PTMASTERSTRENGTH[state.entities.notes.PTOBJECTIVESTRPREV[pk][panel.MOPCOLUMNPREFIX + 'L']].MSTNAME :
                '';
        }
        if (panel.MOPMPTNO === 16) {
            prevStrR = state.entities.notes.PTOBJECTIVESTRPREV[pk][panel.MOPCOLUMNPREFIX + 'R'] ?
                state.entities.notes.PTOBJECTIVESTRPREV[pk][panel.MOPCOLUMNPREFIX + 'R'] :
                '';
            prevStrL = state.entities.notes.PTOBJECTIVESTRPREV[pk][panel.MOPCOLUMNPREFIX + 'L'] ?
                state.entities.notes.PTOBJECTIVESTRPREV[pk][panel.MOPCOLUMNPREFIX + 'L'] :
                '';
        }
    }


    return {
        noteId,
        stno,
        panel,
        flagged,
        prevStr,
        prevStrR,
        prevStrL,
    };
}

const connectedPatientCareCenterNoteObjectiveStrPanel = connect(mapStateToProps)(PatientCareCenterNoteObjectiveStrPanel);
export { connectedPatientCareCenterNoteObjectiveStrPanel as PatientCareCenterNoteObjectiveStrPanel };


